<template>
	<el-dialog :visible.sync="showdownclear" title="下载清关报文" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
		<div class="downmd">
			<el-form ref="form" label-width="100px" size="mini">
				<el-form-item label="面单模板">
					<el-select v-model="info.e_code" style="width:100%">
						<el-option v-for="(item, index) in printmodelist" :key="index" :label="item.e_modename" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="申报类型">
					<el-select v-model="info.cleartype" style="width:100%">
						<el-option v-for="(item, index) in typelist" :key="index" :label="item.name" :value="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="申报单位">
					<el-select v-model="info.companyid" style="width:100%">
						<el-option v-for="(item, index) in companylist" :key="index" :label="item.ds_name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="指运港代码">
					<el-input placeholder="请输入指运港代码" v-model="info.destinationport"></el-input>
				</el-form-item>
				<el-form-item label="抵达时间">
					<el-date-picker
						v-model="info.arrivetime"
						type="date"
						placeholder="选择抵达时间"
						size="mini"
						value-format="yyyy-MM-dd"
					></el-date-picker>
				</el-form-item>
				
				<el-form-item label="上传附件">
					<el-upload 
					  name="fileupload"
					  accept=".zip"
					  class="upload-demo"
					  ref="upload"
					  :multiple="false"
					  :limit="1"
					  :action="fileurl"
					 :on-success="UploadSuccess"
					 :on-error="UploadError"
					 :on-change="UploadChange"
					 :show-file-list="true"
					 :file-list="filelist"
					 :on-exceed="UploadExceed"
					  :auto-upload="false">
					  <el-button slot="trigger" size="small" type="primary" :disabled="uploaddisabled">选取文件</el-button>
					  <span slot="tip" class="el-upload__tip" style="margin-left:10px;color:red">仅允许上传zip压缩文件</span>
					</el-upload>
					<!-- <div style="width:100%;text-align:left;margin-top:5px">{{ filename }}</div> -->
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer" style="padding-top:0px">
				<div style="text-align: center;">
					<el-button type="success" :disabled="btndisabled" size="mini" @click="CheckParam">确 定</el-button>
					<el-button @click="showdownclear = false" size="mini">取 消</el-button>
				</div>
			</span>
		</div>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	data() {
		return {
			showdownclear: false,
			btndisabled:false,
			uploaddisabled:true,
			typelist: [{name:'B'},{name:'A'},{name:'C'},{name:'D'}],
			companylist:[],
			pageparam: {},
			searchinfo: {},
			batch: '',
			divclass: 'downmd',
			filename:'',
			filelist:[],
			fileurl:'',
			info:{
				cleartype:'B',
				companyid:'',
				destinationport:'',
				e_code:'',
				p_mode:'',
				xmltype:'import'
			},
			uploadedfilename:'',
			printmodelist:[],
			userid:localStorage.getItem('userid')
		};
	},
	methods: {
		init(param) {
			this.showdownclear = true;
			this.btndisabled=false;
			this.uploaddisabled=true;
			this.uploadedfilename='';
			if (param.pageparam != undefined) this.pageparam = param.pageparam;
			if (param.searchinfo != undefined) this.searchinfo = param.searchinfo;
			if (param.batch != undefined) this.batch = param.batch;
			this.fileurl =this.$apiprototype.ApiServer +'/Order/GetCompressFile?domain=' +this.$apiprototype.WebServer;
			this.info={
				cleartype:'B',
				companyid:'',
				destinationport:localStorage.getItem('destinationport'),
				e_code:'',
				p_mode:'',
				xmltype:''
			}
			if(param.xmltype!=undefined)
				this.info.xmltype=param.xmltype;
			this.filelist=[];
			this.filename='';
			this.uploadedfilename='';
			var that=this;
			this.$nextTick(function(){
				that.$refs.upload.clearFiles();
			});
			this.LoadCompany();
			this.CheckOrderPmode();
		},
		//检测勾选的订单是否有多个渠道
		CheckOrderPmode(){
			var that = this;
			this.$tool.loading('正在检测', this.divclass);
			this.$apipost.get.CheckOrderPmodeIsMul({ handlerparam:that._data}).then(res => {this.$tool.loadingclose();
				if(res.state=='1')
				{
					that.info.p_mode=res.p_mode;
					that.GetPrintMode();
				}
				else
					this.$tool.message(res.message, 0);
			}).catch(e=>{
				this.$tool.message('系统异常', 0);
				this.$tool.loadingclose();
			});
		},
		//读取权限内的打印模板
		GetPrintMode(){
			this.$tool.loading('正在获取打印模板', this.divclass);
			var that=this;
			var paraminfo={
				p_mode:this.info.p_mode,
				userid:localStorage.getItem('userid')
			}
			this.$apipost.get.GetPrintModeList({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					if(res.list!=undefined){
						if(res.list.length>0){
							that.uploaddisabled=false;
							that.printmodelist=res.list;
							if(res.list.length==1){
								that.info.e_code=res.list[0].id;
							}
						}else
							this.$tool.message('权限内无打印模板', 0);
					}
				}
				else
					this.$tool.message(res.message, 0);
					
			}).catch(e=>{
				this.$tool.message('系统异常', 0);
				this.$tool.loadingclose();
			});
		},
		UploadSuccess(res, file, fileList) {
			this.$tool.loadingclose();
			if (res.state == '1') {
				this.uploadedfilename=res.filename;
				this.CreateClearXml();
			} else {
				this.$tool.message(res.message, 0);
				this.btndisabled=false;
			}
			this.$refs.upload.clearFiles();
		},
		UploadError(err, file, fileList) {
			//console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			if(fileList.length==1){
				this.filename=fileList[0].name;
				this.filelist=fileList;
			}
			else{
				this.filename='';
				this.filelist=[];
			}
		},
		UploadExceed(files, fileList){
			this.$tool.message('请先删除已选择的文件', 0);
		},
		LoadCompany(){
			var that=this;
			this.$apipost.get.GetUserDsList({paraminfo:{type:'申报'} }).then(res => {
				if(res.list!=undefined){
					that.companylist=res.list;
					if(res.list.length==1){
						that.info.companyid=res.list[0].id;
						that.info.ds_name=res.list[0].ds_name;
					}
				}
			}).catch(e=>{
				that.LoadCompany();
			});
		},
		CheckParam(){
			if(this.info.e_code==''){
				this.$tool.message('请选择面单模板', 0);
				return false;
			}
			if(this.info.cleartype==''){
				this.$tool.message('请选择申报类型', 0);
				return false;
			}
			if(this.info.companyid==''){
				this.$tool.message('请选择申报单位', 0);
				return false;
			}
			if(this.info.destinationport==''){
				this.$tool.message('请填写指运港代码', 0);
				return false;
			}
			if(this.filelist.length==0)
			{
				this.$tool.message('请上传附件', 0);
				return false;
			}
			localStorage.setItem('destinationport',this.info.destinationport);
			this.btndisabled=true;
			this.$tool.loading('正在上传', this.divclass);
			this.$refs.upload.submit();
		},
		CreateClearXml(){
			var that=this;
			var paraminfo={
				info:this.info,
				userid:localStorage.getItem('userid'),
				mode:this.pageparam.mode,
				activeName:this.pageparam.activeName,
				searchinfo:this.searchinfo,
				sort:this.pageparam.sort,
				batch:this.batch,
				filename:this.uploadedfilename
			}
			this.$tool.loading('正在生成', this.divclass);
			this.$apipost.post.CreateClearXml({ paraminfo: paraminfo}).then(res => {
				if(res.state=='1'){
					this.$tool.message(res.message, 1);
				}else{
					this.$tool.message(res.message, 0);
					that.btndisabled=false;
				}
				if(res.diskpath!=undefined){
					//下载正确的
					that.DownFile(res.diskpath);
				}
				else{
					this.$tool.loadingclose();
				}
				if(res.localfilename!=undefined){
					that.$tool.downfile(that,res.localfilename,'');//下载错误文件
				}
			}).catch(e=>{
				that.CreateClearXml();
			});
		},
		DownFile(diskpath){
			var that=this;
			var paraminfo={
				diskpath:diskpath,
				filetype:'.zip'
			}
			this.$apipost.post.DownFile({ paraminfo: paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=="1"){
					if(res.localfilename!=undefined){
						that.$tool.downfile(that,decodeURIComponent(res.localfilename),'');//下载已压缩的文件
						//this.$tool.message(res.message,1);
						that.btndisabled=false;
					}
					that.showdownclear=false;
				}
				else{
					this.$tool.message(res.message, 0);
					that.showdownclear=false;
				}
			}).catch(e=>{
				that.DownFile(that);
			});
		}
	}
};
</script>
